module.exports = __webpack_public_path__ + "img/face-happy.b61c3a78.svg";